import React from 'react'

const CcfAudioElement = React.forwardRef<HTMLAudioElement>((_, ref) => (
  // eslint-disable-next-line jsx-a11y/media-has-caption
  <audio ref={ref}></audio>
));

export default CcfAudioElement;
